import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { PageHeaderComponent } from '@nucleus/ui-base';
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";

export interface SupportData {
  userEmail: string;
  tenant: string;
  sessionId: string;
  appVersion: string;
}

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css'],
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule, MatTooltipModule, PageHeaderComponent],
})
export class SupportComponent {

  copied = false;
  private copyResetTimer?: number;

  constructor(
    public dialogRef: MatDialogRef<SupportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SupportData
  ) {}

  copySessionId(): void {
    const value = this.data.sessionId;

    if (!value) {
      return;
    }

    // Prefer modern Clipboard API
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(value).then(() => {
        this.showCopied();
      });
    } else {
      // Fallback (older browsers / edge cases)
      const textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.showCopied();
    }
  }

  private showCopied(): void {
    this.copied = true;

    if (this.copyResetTimer) {
      clearTimeout(this.copyResetTimer);
    }

    this.copyResetTimer = window.setTimeout(() => {
      this.copied = false;
    }, 1500);
  }

  close(): void {
    this.dialogRef.close();
  }
}
